module.exports = require("./hashMap");
